import { h, Component, createRef } from 'preact'
import cn from 'classnames'
import Bubble from '../Bubble'
import s from './CircleButton.css'

interface iProps {
  className?: string
  onClick?: (e: MouseEvent) => void
  size: 'm' | 'l'
  color?: 'blue'
}

class CircleButton extends Component<iProps> {
  static defaultProps = {
    size: 'm'
  }

  render () {
    const {
      className,
      children,
      size,
      color,
      ...restProps
    } = this.props

    return (
      <button
        className={cn(
          s.CircleButton,
          {
            [s.CircleButton_m]: size === 'm',
            [s.CircleButton_l]: size === 'l',
            [s.CircleButton_blue]: color === 'blue',
          },
          className
        )}
        {...restProps}
      >
        <Bubble
          color={color}
          center
        >
          {children}
        </Bubble>
      </button>
    )
  }
}

export default CircleButton
